import { render, staticRenderFns } from "./FormCollapse.vue?vue&type=template&id=6368f2e3&scoped=true"
import script from "./FormCollapse.vue?vue&type=script&lang=ts"
export * from "./FormCollapse.vue?vue&type=script&lang=ts"
import style0 from "./FormCollapse.vue?vue&type=style&index=0&id=6368f2e3&prod&lang=scss&scoped=true"
import style1 from "./FormCollapse.vue?vue&type=style&index=1&id=6368f2e3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6368f2e3",
  null
  
)

export default component.exports